import dotenv from "dotenv";
dotenv.config();

export const CMS_BASE_URL = process.env.REACT_APP_CMS_BASE_URL;

export const ewbConfig = {
  env: process.env.REACT_APP_TEST,
  // appDomain: "ewbcms.eastasia.cloudapp.azure.com",
  // apiUrl: "http://ewbcms.eastasia.cloudapp.azure.com/ewbcms/",

  //production cms
  //appDomain: "cms-corpsite-prod-001.azurewebsites.net",
  //apiUrl: "https://cms-corpsite-prod-001.azurewebsites.net/",

  //beta cms
  //appDomain: "https://ewbcms.azurewebsites.net",
  //apiUrl: "https://ewbcms.azurewebsites.net/",
  ewbApiUrl: process.env.REACT_APP_EWB_API,
  //new beta cms
  appDomain: CMS_BASE_URL,
  apiUrl: `${CMS_BASE_URL}/`,

  apiLink: `${process.env.REACT_APP_EWB_API}/api/`,

  //old blog site
  blogUrl: "https://ewbappswp.azurewebsites.net/wp-json/wp/v2/",
  blogRelativeUrl: "https://ewbappswp.azurewebsites.net",

  //Forms endpoints

  // ewbCCFormAPI: "https://ewbcms.eastasia.cloudapp.azure.com/ewbcms/ewbcc/submit",
  // ewbPLFormAPI: "https://ewbcms.eastasia.cloudapp.azure.com/ewbcms/ewbpl/submit",
  // ewbHLFormAPI: "https://ewbcms.eastasia.cloudapp.azure.com/ewbcms/ewbhl/submit",
  // ewbALFormAPI: "https://ewbcms.eastasia.cloudapp.azure.com/ewbcms/ewbal/submit"

  // Prod CMS
  // ewbCCFormAPI: "https://cms-corpsite-prod-001.azurewebsites.net/ewbcc/submit",
  // ewbPLFormAPI: "https://cms-corpsite-prod-001.azurewebsites.net/ewbpl/submit",
  // ewbHLFormAPI: "https://cms-corpsite-prod-001.azurewebsites.net/ewbhl/submit",
  // ewbALFormAPI: "https://cms-corpsite-prod-001.azurewebsites.net/ewbal/submit",

  // Beta CMS
  ewbCCFormAPI: `${CMS_BASE_URL}/ewbcc/submit`,
  ewbPLFormAPI: `${CMS_BASE_URL}/ewbpl/submit`,
  ewbHLFormAPI: `${CMS_BASE_URL}/ewbhl/submit`,
  ewbALFormAPI: `${CMS_BASE_URL}/ewbal/submit`,
  googleAnalyticsTrackingID: "G-2Y7Y567P71",

  //request for callback
  subscriptionKey: "8B94E6B1-C6D0-4554-9EB1-0C013D3EADF0",
  subscriptionPassword: "!password",
  rfcSender: "onlinedepositleadgeneration@eastwestbanker.com",
  rfcApiUrl: `${process.env.REACT_APP_EWB_API}/api/gateway/sendcustomemail`,
  isTest: process.env.REACT_APP_TEST !== "RELEASE",

  //FX Rates
  fxRatesApiUrl: `${process.env.REACT_APP_EWB_API}/forex/api/forexratesbulletin`,
};
